import * as types from "./ActionTypes";
import * as availableHoursApi from "../../apis/revshare/AvailableHoursApi";
import { addActiveApiCall } from "./ActiveApiActions";

export function loadAvailableHoursSuccess(availableHours) {
  return { type: types.LOAD_AVAILABLE_HOURS_SUCCESS, availableHours };
}

export function loadConsultantsSuccess(consultants) {
  return { type: types.LOAD_CONSULTANTS_SUCCESS, consultants };
}

export function editAvailableHoursSuccess(availableHours) {
  return { type: types.EDIT_AVAILABLE_HOURS_SUCCESS, availableHours };
}

export function loadAvailableHoursHistorySuccess(availableHoursHistory) {
  return { type: types.LOAD_AVAILABLE_HOURS_HISTORY_SUCCESS, availableHoursHistory };
}

export function saveAvailableHoursNoteSuccess(availableHoursId, availableHoursNotes) {
  return {
    type: types.SAVE_AVAILABLE_HOURS_NOTE_SUCCESS,
    data: { id: availableHoursId, availableHoursNotes }
  };
}

export function loadAvailableHoursNotesSuccess(availableHoursId, availableHoursNotes) {
  return {
    type: types.LOAD_AVAILABLE_HOURS_NOTES_SUCCESS,
    data: { id: availableHoursId, availableHoursNotes }
  };
}

export function updateAvailableHoursNoteSuccess(availableHoursId, availableHoursNotes) {
  return {
    type: types.UPDATE_AVAILABLE_HOURS_NOTE_SUCCESS,
    data: { id: availableHoursId, availableHoursNotes }
  };
}

export function removeAvailableHoursNoteSuccess(availableHoursId, availableHoursNotes) {
  return {
    type: types.REMOVE_AVAILABLE_HOURS_NOTE_SUCCESS,
    data: { id: availableHoursId, availableHoursNotes }
  };
}

export function loadConsultants() {
  return function(dispatch) {
    dispatch(addActiveApiCall(types.LOAD_CONSULTANTS_SUCCESS));
    return availableHoursApi
      .getConsultantsWithAvailableHours()
      .then(consultants => {
        dispatch(loadConsultantsSuccess(consultants));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function loadAvailableHours(isAdmin = false, userId = null) {
  return function(dispatch) {
    dispatch(addActiveApiCall(types.LOAD_AVAILABLE_HOURS_SUCCESS));
    return availableHoursApi
      .getAvailableHours(isAdmin, userId)
      .then(availablehours => {
        dispatch(loadAvailableHoursSuccess(availablehours));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function editAvailableHours(availableHoursId, updatedRecord) {
  return function(dispatch) {
    dispatch(addActiveApiCall(types.EDIT_AVAILABLE_HOURS_SUCCESS));
    return availableHoursApi
      .putAvailableHours(availableHoursId, updatedRecord)
      .then(updatedRecord => dispatch(editAvailableHoursSuccess(updatedRecord)))
      .catch(error => {
        throw error;
      });
  };
}

export function loadAvailableHoursHistory(isAdmin = false, userId = null) {
  return function(dispatch) {
    dispatch(addActiveApiCall(types.LOAD_AVAILABLE_HOURS_HISTORY_SUCCESS));
    return availableHoursApi
      .getAvailableHoursHistory(isAdmin, userId)
      .then(availableHoursHistory => {
        dispatch(loadAvailableHoursHistorySuccess(availableHoursHistory));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function saveAvailableHoursNote(note) {
  return function(dispatch) {
    dispatch(addActiveApiCall(types.SAVE_AVAILABLE_HOURS_NOTE_SUCCESS));
    return availableHoursApi
      .postAvailableHoursNote(note)
      .then(availableHoursNotes => {
        dispatch(saveAvailableHoursNoteSuccess(note.availableHoursId, availableHoursNotes));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function updateAvailableHoursNote(noteId, note, availableHoursId) {
  return function(dispatch) {
    dispatch(addActiveApiCall(types.UPDATE_AVAILABLE_HOURS_NOTE_SUCCESS));
    return availableHoursApi
      .updateAvailableHoursNote(noteId, note)
      .then(availableHoursNotes => {
        dispatch(updateAvailableHoursNoteSuccess(availableHoursId, availableHoursNotes));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function loadAvailableHoursNotes(availableHoursId) {
  return function(dispatch) {
    dispatch(addActiveApiCall(types.LOAD_AVAILABLE_HOURS_NOTES_SUCCESS));
    return availableHoursApi
      .getAvailableHoursNotes(availableHoursId)
      .then(availableHoursNotes => {
        dispatch(loadAvailableHoursNotesSuccess(availableHoursId, availableHoursNotes));
      })
      .catch(error => {
        throw error;
      });
  };
}

export function removeAvailableHoursNote(note) {
  return function(dispatch) {
    dispatch(addActiveApiCall(types.REMOVE_AVAILABLE_HOURS_NOTE_SUCCESS));
    return availableHoursApi
      .deleteAvailableHoursNote(note.id)
      .then(availableHoursNotes => {
        dispatch(removeAvailableHoursNoteSuccess(note.availableHoursId, availableHoursNotes));
      })
      .catch(error => {
        throw error;
      });
  };
}
